const BUDGET_ROW_QUERY_KEYS = [
  ['get-swimlanes-in-budget'],
  ['get-swimlanes-details'],
];

const tagMatchesId = (tag, tagId) => {
  const candidateId = tag && typeof tag === 'object' ? tag.id : tag;
  return String(candidateId) === String(tagId);
};

const mapTagAssignments = (value, updateTags) => {
  if (Array.isArray(value)) {
    let changed = false;
    const nextValue = value.map(item => {
      const nextItem = mapTagAssignments(item, updateTags);
      if (nextItem !== item) changed = true;
      return nextItem;
    });
    return changed ? nextValue : value;
  }

  if (!value || typeof value !== 'object') return value;

  let changed = false;
  const nextValue = Object.entries(value).reduce((result, [key, child]) => {
    let nextChild;
    if (key === 'tags' && Array.isArray(child)) {
      nextChild = updateTags(child);
    } else {
      nextChild = mapTagAssignments(child, updateTags);
    }
    if (nextChild !== child) changed = true;
    result[key] = nextChild;
    return result;
  }, {});

  return changed ? nextValue : value;
};

const updateBudgetRowCaches = (queryClient, updateData) => {
  BUDGET_ROW_QUERY_KEYS.forEach(queryKey => {
    queryClient.setQueriesData({ queryKey }, cachedResponse => {
      if (!cachedResponse) return cachedResponse;

      const hasResponseData = Object.hasOwn(cachedResponse, 'data');
      const cachedData = hasResponseData ? cachedResponse.data : cachedResponse;
      const nextData = updateData(cachedData);
      if (nextData === cachedData) return cachedResponse;

      return hasResponseData ? { ...cachedResponse, data: nextData } : nextData;
    });

    queryClient.invalidateQueries({ queryKey, exact: false });
  });
};

export const removeTagAssignments = (value, tagId) =>
  mapTagAssignments(value, tags => {
    const filteredTags = tags.filter(tag => !tagMatchesId(tag, tagId));
    return filteredTags.length === tags.length ? tags : filteredTags;
  });

export const removeTagFromBudgetRowCaches = (queryClient, tagId) => {
  if (!queryClient || tagId === null || tagId === undefined) return;
  updateBudgetRowCaches(queryClient, value =>
    removeTagAssignments(value, tagId)
  );
};

const updateTagList = (tags, updatedTag) => {
  let changed = false;
  const nextTags = tags.map(tag => {
    if (!tagMatchesId(tag, updatedTag.id) || typeof tag !== 'object') {
      return tag;
    }
    changed = true;
    return {
      ...tag,
      name: updatedTag.name,
      color: updatedTag.color,
      ...(Object.hasOwn(tag, 'label') && { label: updatedTag.name }),
      ...(Object.hasOwn(tag, 'value') && { value: updatedTag.name }),
    };
  });
  return changed ? nextTags : tags;
};

export const updateTagInBudgetCaches = (queryClient, updatedTag) => {
  if (!queryClient || updatedTag?.id == null) return;

  queryClient.setQueriesData({ queryKey: ['budget-tags'] }, response => {
    if (!Array.isArray(response?.data)) return response;
    const nextTags = updateTagList(response.data, updatedTag);
    return nextTags === response.data
      ? response
      : { ...response, data: nextTags };
  });

  updateBudgetRowCaches(queryClient, value =>
    mapTagAssignments(value, tags => updateTagList(tags, updatedTag))
  );
};
